import React from 'react';
import PropTypes from 'prop-types';

import {
  getActivationItemStatusUiState,
  isAwaitingAccountNumber,
} from 'common/utility/helpers';

import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrBox from 'client/components/SrBox';

const SrUtilityProfitActivationStatusSummary = ({
  items,
  utilityTypes,
  requiredTypes,
  defaultState,
  completedStates,
  warningStates,
}) => {
  const onClick = ({ label }) => {
    const element = global.document.querySelector(`#section-${label}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div>
      {utilityTypes.map((utilityType) => {
        const item = items.find(({ type }) => utilityType.id === type?.id);
        const { status } = item || {};
        const isRequired = requiredTypes.some(
          ({ utilityTypeId }) => utilityType.id === utilityTypeId,
        );

        const { color, iconUrl, label } = getActivationItemStatusUiState({
          status,
          awaitingAccountNumber: isAwaitingAccountNumber(item),
          defaultState,
          completedStates,
          warningStates,
          label: utilityType.label,
        });

        return (
          <SrFlex
            key={utilityType.id}
            columnGap="8px"
            align="center"
            onClick={() => onClick({ label: utilityType.label })}
          >
            <SrBox
              width="14px"
              height="14px"
              backgroundImage={`url("${iconUrl}")`}
              backgroundSize="cover"
            />
            <SrText
              font="greycliff"
              size="14"
              weight="800"
              color={color}
              {...(!isRequired ? { decoration: 'line-through', cursor: 'pointer' } : { cursor: 'pointer' })}
            >
              {label}
            </SrText>
          </SrFlex>
        );
      })}
    </div>
  );
};

SrUtilityProfitActivationStatusSummary.propTypes = {
  items: PropTypes.array.isRequired,
  defaultState: PropTypes.string,
  completedStates: PropTypes.array,
  warningStates: PropTypes.array,
};

SrUtilityProfitActivationStatusSummary.displayName = 'SrUtilityProfitActivationStatusSummary';

export default SrUtilityProfitActivationStatusSummary;
